import { AnchorHTMLAttributes } from 'react'

import { Button } from '@hhgtech/hhg-components/mantine'
import { useIntl } from 'react-intl'

const ViewAllBtn = ({ ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) => {
  const { formatMessage: f } = useIntl()
  return (
    <a target="_blank" {...props}>
      <Button
        variant="white"
        sx={() => ({
          width: '100%',
          backgroundColor: '#fff',
        })}
      >
        {f({ id: 'categoryPage.seeAll' })}
      </Button>
    </a>
  )
}

export { ViewAllBtn }
